import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { ActionGroup } from 'src/components/buttons-and-actions/action-group';
import { Link } from 'src/components/navigation/link';
import type { PageParams } from 'src/pages/storage/locations/use-page-params';

type Props = {
  pageParams: PageParams;
};

export const QuickFiltersBar: FC<Props> = ({ pageParams }) => {
  return (
    <div>
      <ActionGroup mode="segmented-control">
        <Link
          data-testid="quickFilter-showAll"
          isSelected={!pageParams.value.favoritesOnly}
          to={{ search: pageParams.toSearchParams({ favoritesOnly: false }) }}
        >
          All
        </Link>

        <Link
          data-testid="quickFilter-favouritesOnly"
          isSelected={pageParams.value.favoritesOnly}
          to={{ search: pageParams.toSearchParams({ favoritesOnly: true }) }}
        >
          <FontAwesomeIcon icon={faStar} /> Your SSO's only
        </Link>
      </ActionGroup>
    </div>
  );
};
